import Vue from 'vue';
import Vuex from 'vuex';

import user from './user';
import materials from './materials';
import courses from './courses';
import webinars from './webinars';
import teacher from './teacher';
import transactions from './transactions';
import admin from './admin';
import technical from './technical';
import app from './app';
import appConfig from './app-config';
import verticalMenu from './vertical-menu';
import crm from './crm';
import subjects from './studying-materials/subjects';
import programs from './studying-materials/programs';
import lessons from './studying-materials/lessons';
import lessonRoom from './lessonRoom';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    materials,
    courses,
    webinars,
    teacher,
    transactions,
    admin,
    technical,
    app,
    appConfig,
    verticalMenu,
    crm,
    subjects,
    programs,
    lessons,
    lessonRoom
  },
});
